/**
 * Import all module dependencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import rsaRoute from './rsa.route';
import registerRoute from './register/rsa.register.route';
import confirmRoute from './confirm/rsa.confirm.route';
import verifyRoute from './verify/rsa.verify.route';
import rsaRegisterController from './register/rsa.register.controller';
import rsaConfirmController from './confirm/rsa.confirm.controller';
import rsaVerifyController from './verify/rsa.verify.controller';
import rsaController from './rsa.controller';

/**
 * This is the securityquestion module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace securityquestion Module
 */
angular.module('securityquestionRsa', [
  // Shared modules.
  core
])
// Register route.
.config(rsaRoute)
.config(registerRoute)
.config(confirmRoute)
.config(verifyRoute)
// Register controller.
.controller('rsaController', rsaController)
.controller('rsaRegisterController', rsaRegisterController)
.controller('rsaConfirmController', rsaConfirmController)
.controller('rsaVerifyController', rsaVerifyController);

export default 'securityquestionRsa';


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/rsa.module.js